import { gateway } from "../../../../gateway";

export const updateSupplyProvider = async ({ token, data , id }) => {
  try {
    const res = await gateway.patch(
      `/supplies/providers/self/${id}`,
      data,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
